<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { FluidityModule } from '@ibgroup-tws-webapps/fluidity';
import { useMediaQuery } from '@vueuse/core';
import { useUserState } from '@/stores/useUserState';

interface Props {
  // Every product conid for this race across exchanges (FORECASTX + matched
  // siblings on KALSHI, etc.) so positions/orders for all sibling products
  // surface in one Activity table — same paradigm as ProductContracts.vue.
  conids: number[];
}

const props = defineProps<Props>();

const userState = useUserState();
const isMobile = useMediaQuery('(max-width: 799px)');
const { t } = useI18n();
</script>

<template>
  <div class="election-chart-container w-full relative overflow-hidden">
    <h5 v-if="!isMobile" class="text-lg font-medium text-on-surface mb-4">{{ t('yourActivity') }}</h5>
    <FluidityModule
      moduleName="orders.trades2"
      mountModuleKey="ModuleYourActivity"
      :module-props="{
        conids: props.conids,
        account: userState.account,
      }"
    >
    </FluidityModule>
  </div>
</template>
